import { createSlice } from "@reduxjs/toolkit";
import { getExportHistoryData } from "../thunk/exportHistoryThunk";

export interface ListType {
  export_type: string;
  file: string;
  status: string;
  sk: string;
  time: number;
  username: string;
  pk: string;
  user_data: {
    name: string;
    email: string;
  };
}

export type InitialStateType = {
  items: ListType[];
};

const intialState: InitialStateType = {
  items: [],
};
const exportHistory = createSlice({
  initialState: intialState,
  name: "exportHistory",
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getExportHistoryData.fulfilled, (state, action) => {
      return {
        items: action?.payload?.items || [],
      };
    });
  },
});

export const {} = exportHistory?.actions;
export default exportHistory.reducer;
